module.exports = __webpack_public_path__ + "img/IMG_0122.a5053d2b.png";